<svg
  class="spinner-chase"
  xmlns="http://www.w3.org/2000/svg"
  width="48"
  height="48"
  viewBox="0 0 48 48"
  role="img"
  [attr.aria-label]="ariaLabel"
>
  <style>
    .spinner-chase {
      display: inline-block;
    }

    .spinner-chase .dot circle {
      fill: var(--ds-fg-brand-primary);
      opacity: 0; /* baseline dim */
      animation: chase 1.2s linear infinite;
      animation-delay: calc(var(--i) * -0.1s); /* stagger in order */
    }

    @keyframes chase {
      0% {
        opacity: 1;
      }
      100% {
        opacity: 0;
      }
    }

    @media (prefers-reduced-motion: reduce) {
      .spinner-chase .dot circle {
        animation-duration: 2.4s;
      }
    }
  </style>
  <g transform="translate(24 24)">
    <g class="dot" style="--i:0" transform="rotate(  0)">
      <circle cx="0" cy="-18" r="3"/>
    </g>
    <g class="dot" style="--i:1" transform="rotate( 30)">
      <circle cx="0" cy="-18" r="3"/>
    </g>
    <g class="dot" style="--i:2" transform="rotate( 60)">
      <circle cx="0" cy="-18" r="3"/>
    </g>
    <g class="dot" style="--i:3" transform="rotate( 90)">
      <circle cx="0" cy="-18" r="3"/>
    </g>
    <g class="dot" style="--i:4" transform="rotate(120)">
      <circle cx="0" cy="-18" r="3"/>
    </g>
    <g class="dot" style="--i:5" transform="rotate(150)">
      <circle cx="0" cy="-18" r="3"/>
    </g>
    <g class="dot" style="--i:6" transform="rotate(180)">
      <circle cx="0" cy="-18" r="3"/>
    </g>
    <g class="dot" style="--i:7" transform="rotate(210)">
      <circle cx="0" cy="-18" r="3"/>
    </g>
    <g class="dot" style="--i:8" transform="rotate(240)">
      <circle cx="0" cy="-18" r="3"/>
    </g>
    <g class="dot" style="--i:9" transform="rotate(270)">
      <circle cx="0" cy="-18" r="3"/>
    </g>
    <g class="dot" style="--i:10" transform="rotate(300)">
      <circle cx="0" cy="-18" r="3"/>
    </g>
    <g class="dot" style="--i:11" transform="rotate(330)">
      <circle cx="0" cy="-18" r="3"/>
    </g>
  </g>
</svg>
